import { Component, ViewContainerRef, OnInit, Input, OnChanges } from '@angular/core';
import { GraphBar } from '../../../_models/graph/GraphBar';


@Component({
    selector: 'app-bar-graph',
    templateUrl: './bar-graph.component.html',
    styleUrls: ['./bar-graph.component.css']
})

export class BarGraphComponent implements OnChanges{
    
    @Input()
    public bars: GraphBar[];

    @Input()
    public xAxis: string;
    @Input()
    public yAxis: string;

    @Input()
    public colors: string[];

    @Input()
    public width: number;

    @Input()
    public height: number;

    @Input()
    public isCurrency: boolean;

    public tallestBar: number = 0;

    ngOnChanges(){
        for (let bar of this.bars){
            if (bar.size > this.tallestBar){
                this.tallestBar = bar.size;
            }
        }
    }

}

